import { Component, OnInit, AfterViewInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
//Import Custom Services Here
import { SchoolGroupService } from "../report-services/school-group.service";
import { VisitorStatusService } from "../report-services/visitor-status.service";
import { VisitorTypeService } from "../report-services/visitor-type.service";
import * as moment from "moment";
import { UserService } from "../../../shared";

@Component({
	templateUrl: "./visitorsbycontainer.component.html",
})
export class VisitorsbyContainerComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private visitortypeService: VisitorTypeService,
		private visitorstatusService: VisitorStatusService,
		private schoolgroupService: SchoolGroupService,
		private dialogService: DialogService,
		private userService: UserService
	) {}
	report = {
		SchoolID: 0,
		//Insert Custom Parameters Here
		SchoolGroupID: 0,
		StartDate: new Date(),
		EndDate: new Date(),
		PeriodID: "Today",
		VisitorStatusID: 0,
		VisitorTypeID: 0,
		ShowDetailID: "Yes",
		ImageLogo: "",
	};
	//Insert Custom Lists Here
	SchoolGroupList: any = [];
	VisitorStatusList: any = [];
	VisitorTypeList: any = [];
	ImageLogoList: any = [];

	subscription: any;

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	PeriodList = [
		//Insert Custom List Items Here
		{
			PeriodID: "Today",
			PeriodName: "Today",
		},
		{
			PeriodID: "Current week",
			PeriodName: "Current week",
		},
		{
			PeriodID: "Current month",
			PeriodName: "Current month",
		},
		{
			PeriodID: "Date range",
			PeriodName: "Date range",
		},
	];

	ShowDetailList = [
		//Insert Custom List Items Here
		{
			ShowDetailID: "Yes",
			ShowDetailName: "Yes",
		},
		{
			ShowDetailID: "No",
			ShowDetailName: "No",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 394;

	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		//Insert Custom Init Methods Here
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});

		this.loadSchoolGroupList();
		this.loadVisitorStatusList();
		this.loadVisitorTypeList();
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadLogolist();
	}

	private loadSchoolGroupList() {
		this.report.SchoolGroupID = 0;
		var result = this.schoolgroupService.loadSchoolGroupList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.SchoolGroupList = response;

				if (this.SchoolGroupList.length > 1) {
					// this.SchoolGroupList.unshift({
					//     SchoolGroupID: 0,
					//     SchoolGroupDesc: "All SchoolGroups"
					// })
					this.report.SchoolGroupID = this.SchoolGroupList[0].SchoolGroupID;
				} else {
					this.report.SchoolGroupID = this.SchoolGroupList[0].SchoolGroupID;
				}
			},
			(error) => {}
		);
	}

	private loadVisitorStatusList() {
		this.report.VisitorStatusID = 0;
		var result = this.visitorstatusService.loadVisitorStatusList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.VisitorStatusList = response;

				if (this.VisitorStatusList.length > 1) {
					// this.VisitorStatusList.unshift({
					//     VisitorStatusID: 0,
					//     VisitorStatusDesc: "All VisitorStatuss"
					// })
					this.report.VisitorStatusID = this.VisitorStatusList[0].VisitorStatusID;
				} else {
					this.report.VisitorStatusID = this.VisitorStatusList[0].VisitorStatusID;
				}
			},
			(error) => {}
		);
	}

	private loadVisitorTypeList() {
		this.report.VisitorTypeID = 0;
		var result = this.visitortypeService.loadVisitorTypeList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.VisitorTypeList = response;

				if (this.VisitorTypeList.length > 1) {
					// this.VisitorTypeList.unshift({
					//     VisitorTypeID: 0,
					//     VisitorTypeDesc: "All VisitorTypes"
					// })
					this.report.VisitorTypeID = this.VisitorTypeList[0].VisitorTypeID;
				} else {
					this.report.VisitorTypeID = this.VisitorTypeList[0].VisitorTypeID;
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		// if (!this.report.SchoolGroupID) {
		// 	this.errorMessage = "Select the SchoolGroup"
		// 	return;
		// }

		// if (!this.report.StartDate) {
		// 	this.errorMessage = "Select the StartDate"
		// 	return;
		// }

		// if (!this.report.EndDate) {
		// 	this.errorMessage = "Select the EndDate"
		// 	return;
		// }

		// if (!this.report.PeriodID) {
		// 	this.errorMessage = "Select the Period"
		// 	return;
		// }

		// if (!this.report.VisitorStatusID) {
		// 	this.errorMessage = "Select the VisitorStatus"
		// 	return;
		// }

		// if (!this.report.VisitorTypeID) {
		// 	this.errorMessage = "Select the VisitorType"
		// 	return;
		// }

		// if (!this.report.ShowDetailID) {
		// 	this.errorMessage = "Select the ShowDetail"
		// 	return;
		// }

		// if (!this.report.UserID) {
		// 	this.errorMessage = "Select the User"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 394;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: SchoolGroupID
		strParam += this.report.SchoolGroupID + "|SchoolGroupID";

		//Parameter 2: StartDate
		strParam += "," + moment(this.report.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 3: EndDate
		strParam += "," + moment(this.report.EndDate).format("MM/DD/YYYY") + "|EndDate";

		//Parameter 4: Period
		strParam += "," + this.report.PeriodID + "|Period";

		//Parameter 5: VisitorStatusID
		strParam += "," + this.report.VisitorStatusID + "|VisitorStatusID";

		//Parameter 6: VisitorTypeID
		strParam += "," + this.report.VisitorTypeID + "|VisitorTypeID";

		//Parameter 7: ShowDetail
		strParam += "," + this.report.ShowDetailID + "|ShowDetail";

		//Parameter 8: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		//Parameter 9: UserID
		strParam += "," + this.user.userID + "|UserID";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
